import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { GiDiceTwentyFacesTwenty } from 'react-icons/gi';
import SafeIcon from '../../common/SafeIcon';

const DiceRoller = ({ onRoll, disabled }) => {
  const [isRolling, setIsRolling] = useState(false);
  const [result, setResult] = useState(null);

  const rollDice = () => {
    if (disabled || isRolling) return;

    setIsRolling(true);
    setResult(null);

    // Simulate roll animation duration
    setTimeout(() => {
      const value = Math.floor(Math.random() * 20) + 1;
      setResult(value);
      setIsRolling(false);
      if (onRoll) {
        onRoll(value);
      }

      // Clear result display after a few seconds
      setTimeout(() => {
        setResult(null);
      }, 3000);
    }, 1000);
  };

  return (
    <div className="relative flex items-center justify-center">
      <motion.button
        type="button"
        onClick={rollDice}
        disabled={disabled || isRolling}
        animate={isRolling ? {
          rotate: [0, 90, 180, 270, 360, 450, 540, 630, 720],
          scale: [1, 1.2, 1, 1.2, 1],
          y: [0, -20, 0, -10, 0]
        } : { rotate: 0, scale: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
        className={`p-2 rounded-full transition-colors flex items-center justify-center ${disabled ? 'text-gray-400 cursor-not-allowed' : 'text-amber-500 hover:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/20'}`}
        title="Roll D20"
      >
        <SafeIcon icon={GiDiceTwentyFacesTwenty} className="text-3xl" />
      </motion.button>

      <AnimatePresence>
        {result !== null && (
          <motion.div
            initial={{ opacity: 0, y: 10, scale: 0.5 }}
            animate={{ opacity: 1, y: -40, scale: 1.2 }}
            exit={{ opacity: 0, y: -50, scale: 0.8 }}
            className="absolute font-black text-amber-500 drop-shadow-md text-xl z-20 pointer-events-none"
          >
            {result}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default DiceRoller;
